/* ClearZal image reliability helper — V15 performance edition.
   Keep native lazy-loading intact so below-the-fold images do not compete
   with the first screen. Only prepare decoding and retry a failed request once. */
(function () {
  'use strict';

  function retryOnce(img) {
    if (!img || img.dataset.czRetried === '1') return;
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return;
    img.dataset.czRetried = '1';

    window.setTimeout(function () {
      var srcset = img.getAttribute('srcset');
      var sizes = img.getAttribute('sizes');
      img.removeAttribute('src');
      if (srcset) img.removeAttribute('srcset');

      requestAnimationFrame(function () {
        if (sizes) img.setAttribute('sizes', sizes);
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', src);
      });
    }, 500);
  }

  function prepare(img) {
    if (!img || img.dataset.czPrepared === '1') return;
    img.dataset.czPrepared = '1';
    img.decoding = 'async';
    img.addEventListener('error', function () { retryOnce(img); }, { once: true });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('.page img'), prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  /* Shopify theme editor can re-render sections without a full page reload. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
